import { FC, useEffect } from 'react'
import { useParams } from 'react-router-dom';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { getResult } from 'store/player/playerAsync';
// Selectors
import { selectResult } from 'store/player/playerSelectors';
// Components
import PublicDevicePlayable from 'components/PublicDevicePlayable';
import AppBar from 'components/AppBar';
import { Button } from 'components/Buttons';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// 
import TextCountdown from './TextCountdown';
// i18next
import { useTranslation } from 'react-i18next';

const QuizGroupPage:FC = () => {
  const { t } = useTranslation();

  const { groupSlug } = useParams<{ groupSlug:string }>();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const result:any = useAppSelector(selectResult);
  
  const navigateTo = useNavigateTo();

  useEffect(() => {
    dispatch(getResult({ quizGroupName: groupSlug, limit: 96 }))
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( result && result.quizGroup ){
      // Set default primary
      document.documentElement.style.setProperty('--primaryColor', result.quizGroup.theme.primaryColor);
      document.documentElement.style.setProperty('--primaryFontColor', result.quizGroup.theme.primaryFontColor);
      document.documentElement.style.setProperty('--primaryButtonGradientStart', result.quizGroup.theme.primaryButtonGradientStart);
      document.documentElement.style.setProperty('--primaryButtonGradientEnd', result.quizGroup.theme.primaryButtonGradientEnd);
      document.documentElement.style.setProperty('--primaryButtonFontColor', result.quizGroup.theme.primaryButtonFontColor);
    }
    // eslint-disable-next-line
  }, [result])

  const handleClick = () => {
    navigateTo('quiz-group-leaderboard');
  }

  if ( !result || !result.quizGroup ) return null;
  return (
    <div
      className="flex-1 flex flex-col"
      style={{ background: result.quizGroup.backgroundImage ? `url('${result.quizGroup.backgroundImage}') top / cover` : '' }}
    >
      <PublicDevicePlayable />
      <div
        className="flex-1 p-4 overflow-y-auto flex flex-col"
      >
        <AppBar handleBack={() => navigateTo('post-quiz')} />
        <div className="flex justify-center my-4">
          <h1 className="text-primary font-bold text-4xl text-center">{result.quizGroup.name}</h1>
        </div>
        <TextCountdown
          quizzes={result.quizGroup.quizzes}
          prizes={result.quizGroup.prizes?.filter(Boolean) || []}
        />
        {result.quizGroup.callToActionImageUrl ? (
          <a
            className="w-11/12 mx-auto block rounded mb-4 overflow-hidden border border-white"
            href={result.quizGroup.callToActionLinkUrl || undefined}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={result.quizGroup.callToActionImageUrl}
              alt={result.quizGroup.callToActionButtonText || `${t('buttons.visit')} ${result.quizGroup.slug}`}
            />
          </a>
        ) : null}
        <div className="flex-1" />
        {result.quizGroup.callToActionLinkUrl ? (
          <a href={result.quizGroup.callToActionLinkUrl} target="_blank" rel="noreferrer" className="w-11/12 mx-auto">
            <Button
              className="w-full !text-xl primary-button normal-case"
              size="small"
            >
              {result.quizGroup.callToActionButtonText || `${t('buttons.visit')} ${result.quizGroup.slug}`}
            </Button>
          </a>
        ) : null}
        <div className="text-center my-4">
          <Button
            className="w-11/12 mx-auto !text-xl primary-button capitalize"
            size="small"
            onClick={handleClick}
          >{t('buttons.leaderboard')}</Button>
        </div>
      </div>
    </div>
  )
}

export default QuizGroupPage;
